import { render } from "./BookErrorCorrectionDialog.vue?vue&type=template&id=0b6b0f11&scoped=true"
import script from "./BookErrorCorrectionDialog.vue?vue&type=script&lang=js"
export * from "./BookErrorCorrectionDialog.vue?vue&type=script&lang=js"

import "./BookErrorCorrectionDialog.vue?vue&type=style&index=0&id=0b6b0f11&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6b0f11"]])

export default __exports__